const faqBaseUrl = 'https://faq.endaoment.org';

export const home = () => faqBaseUrl;

export const introduction = () => `${faqBaseUrl}/introduction`;
